import { render, staticRenderFns } from "./MenuMudarPedidoSelecionado.vue?vue&type=template&id=3c4252d0&scoped=true"
import script from "./MenuMudarPedidoSelecionado.vue?vue&type=script&lang=js"
export * from "./MenuMudarPedidoSelecionado.vue?vue&type=script&lang=js"
import style0 from "./MenuMudarPedidoSelecionado.vue?vue&type=style&index=0&id=3c4252d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4252d0",
  null
  
)

export default component.exports